const EmptyAssets = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 244 124' fill='none'>
			<g filter='url(#filter0_d_11721_80311)'>
				<path
					d='M34 51C34 46.5817 37.5817 43 42 43H202C206.418 43 210 46.5817 210 51V90C210 94.4183 206.418 98 202 98H42C37.5817 98 34 94.4183 34 90V51Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter1_d_11721_80311)'>
				<path
					d='M202 97.5996V98H42V97.5996H202ZM209.6 90V51C209.6 46.8026 206.197 43.4004 202 43.4004H42C37.8026 43.4004 34.4004 46.8026 34.4004 51V90C34.4004 94.1974 37.8026 97.5996 42 97.5996V98C37.5817 98 34 94.4183 34 90V51C34 46.5817 37.5817 43 42 43H202L202.412 43.0107C206.639 43.2252 210 46.7199 210 51V90C210 94.2801 206.639 97.7748 202.412 97.9893L202 98V97.5996C206.197 97.5996 209.6 94.1974 209.6 90Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<g filter='url(#filter2_d_11721_80311)'>
				<path
					d='M22 45C22 39.4772 26.4772 35 32 35H212C217.523 35 222 39.4772 222 45V80C222 85.5228 217.523 90 212 90H32C26.4772 90 22 85.5228 22 80V45Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter3_d_11721_80311)'>
				<path
					d='M212 89.5996V90H32V89.5996H212ZM221.6 80V45C221.6 39.6981 217.302 35.4004 212 35.4004H32C26.6981 35.4004 22.4004 39.6981 22.4004 45V80C22.4004 85.3019 26.6981 89.5996 32 89.5996V90C26.6498 90 22.2805 85.7983 22.0127 80.5146L22 80V45C22 39.4772 26.4772 35 32 35H212L212.515 35.0127C217.798 35.2805 222 39.6498 222 45V80L221.987 80.5146C221.728 85.6279 217.628 89.7281 212.515 89.9873L212 90V89.5996C217.302 89.5996 221.6 85.3019 221.6 80Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<g filter='url(#filter4_d_11721_80311)'>
				<path
					d='M10 38C10 31.3726 15.3726 26 22 26H222C228.627 26 234 31.3726 234 38V70C234 76.6274 228.627 82 222 82H22C15.3726 82 10 76.6274 10 70V38Z'
					fill='white'
				/>
			</g>
			<g filter='url(#filter5_d_11721_80311)'>
				<path
					d='M222 81.5996V82H22V81.5996H222ZM233.6 70V38C233.6 31.5935 228.407 26.4004 222 26.4004H22C15.5935 26.4004 10.4004 31.5935 10.4004 38V70C10.4004 76.4065 15.5935 81.5996 22 81.5996V82L21.6904 81.9961C15.309 81.8345 10.1655 76.691 10.0039 70.3096L10 70V38C10 31.3726 15.3726 26 22 26H222C228.627 26 234 31.3726 234 38V70L233.996 70.3096C233.835 76.691 228.691 81.8345 222.31 81.9961L222 82V81.5996C228.407 81.5996 233.6 76.4065 233.6 70Z'
					fill='#D0D2DC'
					fillOpacity='0.5'
					shapeRendering='crispEdges'
				/>
			</g>
			<path
				d='M22 46C22 41.5817 25.5817 38 30 38H46C50.4183 38 54 41.5817 54 46V62C54 66.4183 50.4183 70 46 70H30C25.5817 70 22 66.4183 22 62V46Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M66 64C66 61.7909 67.7909 60 70 60H94C96.2091 60 98 61.7909 98 64C98 66.2091 96.2091 68 94 68H70C67.7909 68 66 66.2091 66 64Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M194 64C194 61.7909 195.791 60 198 60H218C220.209 60 222 61.7909 222 64C222 66.2091 220.209 68 218 68H198C195.791 68 194 66.2091 194 64Z'
				fill='#96A4B5'
				fillOpacity='0.16'
			/>
			<path
				d='M66 44C66 41.7909 67.7909 40 70 40H125C127.209 40 129 41.7909 129 44V48C129 50.2091 127.209 52 125 52H70C67.7909 52 66 50.2091 66 48V44Z'
				fill='#96A4B5'
				fillOpacity='0.2'
			/>
			<path
				d='M212.853 51.1436C212.497 51.1436 212.176 50.918 212.176 50.5488C212.176 50.3506 212.23 50.2207 212.333 50.0703L215.279 45.7568L218.212 41.4092C218.424 41.0947 218.588 40.9854 218.909 40.9854C219.271 40.9854 219.552 41.2383 219.552 41.5869C219.552 41.751 219.497 41.8945 219.395 42.0518L216.544 46.2354L213.502 50.7334C213.304 51.041 213.133 51.1436 212.853 51.1436ZM212.306 46.3105C210.932 46.3105 210.07 45.3057 210.07 43.6445C210.07 41.9766 210.938 40.999 212.306 40.999C213.666 40.999 214.534 41.9697 214.534 43.6445C214.534 45.2988 213.673 46.3105 212.306 46.3105ZM212.306 45.2031C212.777 45.2031 213.071 44.7109 213.071 43.6445C213.071 42.5781 212.777 42.1064 212.306 42.1064C211.834 42.1064 211.533 42.5781 211.533 43.6445C211.533 44.7109 211.827 45.2031 212.306 45.2031ZM219.442 51.1367C218.068 51.1367 217.207 50.1318 217.207 48.4639C217.207 46.7959 218.082 45.8184 219.442 45.8184C220.803 45.8184 221.678 46.7891 221.678 48.4639C221.678 50.125 220.816 51.1367 219.442 51.1367ZM219.442 50.0293C219.914 50.0293 220.215 49.5303 220.215 48.4639C220.215 47.3975 219.914 46.9258 219.442 46.9258C218.971 46.9258 218.67 47.3975 218.67 48.4707C218.67 49.5303 218.971 50.0293 219.442 50.0293Z'
				fill='#EAEDF0'
			/>
			<path
				d='M205.081 51.2188C202.579 51.2188 201.055 49.2432 201.055 46.0508C201.055 42.8652 202.593 40.9102 205.081 40.9102C207.569 40.9102 209.101 42.8584 209.101 46.0439C209.101 49.2295 207.583 51.2188 205.081 51.2188ZM205.081 49.5645C206.298 49.5645 207.002 48.3135 207.002 46.0508C207.002 43.8018 206.291 42.5645 205.081 42.5645C203.878 42.5645 203.153 43.8086 203.153 46.0508C203.153 48.3135 203.864 49.5645 205.081 49.5645Z'
				fill='#EAEDF0'
			/>
			<path
				d='M198.741 51.082C198.126 51.082 197.641 50.5898 197.641 49.9814C197.641 49.3662 198.126 48.8809 198.741 48.8809C199.35 48.8809 199.842 49.3662 199.842 49.9814C199.842 50.5898 199.35 51.082 198.741 51.082Z'
				fill='#EAEDF0'
			/>
			<path
				d='M192.542 51.2188C190.04 51.2188 188.516 49.2432 188.516 46.0508C188.516 42.8652 190.054 40.9102 192.542 40.9102C195.03 40.9102 196.562 42.8584 196.562 46.0439C196.562 49.2295 195.044 51.2188 192.542 51.2188ZM192.542 49.5645C193.759 49.5645 194.463 48.3135 194.463 46.0508C194.463 43.8018 193.752 42.5645 192.542 42.5645C191.339 42.5645 190.614 43.8086 190.614 46.0508C190.614 48.3135 191.325 49.5645 192.542 49.5645Z'
				fill='#EAEDF0'
			/>
			<path
				d='M37.7909 44.364C38.526 43.7981 39.5473 43.9038 40.1623 44.5991C42.2209 46.9262 46.5 52.125 46.5 55.1317C46.5 60.0295 43.3316 64 38.4497 64C33.644 64 29.7338 60.1524 29.613 55.3603C29.2908 52.5758 29.7219 49.7165 30.1019 47.9272C30.3186 46.9073 31.3564 46.3531 32.3306 46.7165C32.8774 46.9206 33.5156 47.1721 34.1927 47.4657C35.5135 46.179 36.8498 45.0884 37.7909 44.364ZM38.4479 53.5255C38.2294 53.3413 37.9165 53.3413 37.6981 53.5255C36.8616 54.231 34.9161 56.0178 34.916 57.3748C34.916 59.1034 36.3295 60.5048 38.073 60.5049C39.8165 60.5049 41.2299 59.1034 41.2299 57.3748C41.2299 56.0177 39.2843 54.231 38.4479 53.5255Z'
				fill='white'
			/>
			<defs>
				<filter
					id='filter0_d_11721_80311'
					x='24'
					y='38'
					width='196'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
				<filter
					id='filter1_d_11721_80311'
					x='24'
					y='38'
					width='196'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
				<filter
					id='filter2_d_11721_80311'
					x='12'
					y='30'
					width='220'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
				<filter
					id='filter3_d_11721_80311'
					x='12'
					y='30'
					width='220'
					height='75'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
				<filter
					id='filter4_d_11721_80311'
					x='0'
					y='21'
					width='244'
					height='76'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
				<filter
					id='filter5_d_11721_80311'
					x='0'
					y='21'
					width='244'
					height='76'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='5' />
					<feGaussianBlur stdDeviation='5' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_11721_80311' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_11721_80311' result='shape' />
				</filter>
			</defs>
		</svg>
	);
};

export default EmptyAssets;
